<template>
  <div class="">
    <div v-if="column == 'installation_name'">
      <b>{{ item.installation_name }}</b>
      <small >
        <br>
        {{item.city}}
      </small>
    </div>
    <div v-if="column == 'company_name'">
      <b>{{ item.company_name}} </b>
      <small v-if="item.nb_alarm!== undefined" style="display:flex; flex-wrap: nowrap;">
        <br>
          <div style="height: 10px; width: 10px; background-color: brown; border-radius: 50%; margin-right: 5px;"></div>
          {{item.nb_alarm}} {{$t('_alarme_non_resolues_')}}
      </small>
    </div>

  </div>
</template>

<script>


export default {
  props: {
    item: {
      required: true,
    },

    column: {
      type: String,
      required: true,
    },
  },
    
  data() {
    return {
      isAdmin: this.getRole() === 'admin',

      degreesArrows: {
        constant: 1,
        half: 4.99,
        max: 5,
      },

      degreesBackgrounds: {
        pr: {
          red: 70,
        },
        ip: {
          red: 85,
          orange: 94.99,
          green: 95
        },
      }

    };
  },


  methods: {
    getRole() {
      return this.$store.state.authStore.role
    },

    parseDate(dt) {
      if (dt !== undefined) {
        const splitted = dt.split('-')
        if (splitted.length < 3) return dt
        return `${splitted[2]}-${splitted[1]}-${splitted[0]}`
      } else {
        return ''
      }
    },
  },

};
</script>

<style scoped>
  td > div {
    height: 100%;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .red-field {
    background-color: #ffaaa7;
  }

  .orange-field {
    background-color: #ffd3b4;
  }

  .green-field {
    background-color:  #d5ecc2;
  }
</style>
